import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { ContractAiAnalysisService } from '../service';

import { AiUsage } from '../model';

/** Header pill state: still loading, usage ready, or no plan / backend unavailable. */
export type AiUsageState = { status: 'loading' } | { status: 'ready'; usage: AiUsage } | { status: 'unavailable' };

/**
 * Single source of truth for the advisor's AI token budget. Drives the header usage pill
 * and can be reused by any future usage widget.
 */
@Injectable({ providedIn: 'root' })
export class ContractAiAnalysisLocalService {
  private readonly state = new BehaviorSubject<AiUsageState>({ status: 'loading' });

  constructor(private readonly smartAnalysisService: ContractAiAnalysisService) {}

  public get observable(): Observable<AiUsageState> {
    return this.state.asObservable();
  }

  public refresh(): void {
    this.smartAnalysisService.getUsage().subscribe({
      next: (usage: AiUsage): void => this.state.next({ status: 'ready', usage }),
      error: (error): void => {
        console.log(error);
        this.state.next({ status: 'unavailable' }); // no plan / unavailable → pill shows upgrade CTA only
      },
    });
  }
}
